const generateKeycloakUrl = (kcAction) => {
  const params = new URLSearchParams({
    client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    response_type: 'code',
    scope: 'openid',
    redirect_uri: `${window.location.origin}/auth/callback`,
  });

  if (kcAction) {
    params.append('kc_action', kcAction);
  }

  const base = process.env.REACT_APP_KEYCLOAK_URL;
  const realm = process.env.REACT_APP_KEYCLOAK_REALM;
  return `${base}/realms/${realm}/protocol/openid-connect/auth?${params}`;
};

export const getKeycloakAuthUrl = () => generateKeycloakUrl();
export const getKeycloakUpdatePasswordUrl = () => generateKeycloakUrl('UPDATE_PASSWORD');
